// @ts-nocheck
import React, { useEffect, useReducer, useRef  } from "react";
import { Heading } from './heading.module.js';
import {Module} from './module.js';
import  {TagsSelector} from './tags.selector.js';
import  {TechnologySelector} from './technology.selector.js';
import {ActionTable} from './action.table.js';
import {ListSelector} from './list.selector.js';
import  {PreviewTable} from './preview.table.js';
import { Block } from './block.js';
import { FiltersSelector } from './filters.selector.js';
import { CallListFilter } from './call.filter.list.js';
import { ReportsSearch, ReportsSearchEncode, ReportsSearchQuery } from '../reports/reports.requests.js';
import { useSearchParams} from 'react-router-dom'

// Interface for criteria item
interface CriteriaItem {
	type: string;
	module: string;
	child?: boolean;
	noedit?: boolean;
	title?: string;
	value?: string;
	version?: string;
	icon?: string;
}

// Interface for search data
interface SearchData {
	token: string;
	progress: number;
	discovered: number;
	max: number;
	completed: boolean;
	list: CriteriaItem[];
}

// Interface for component state
interface ReportsBodyLeftState {
	selected: boolean;
	iteration: number;
	focus: string;
	searchToken: string;
	searchProgress: number;
	searchDiscovered: number;
	searchMax: number;
	searchCompleted: boolean;
	searchList: wts_ignore_any[];
	list: CriteriaItem[];
}

// Interface for component props
interface ReportsBodyLeftProps {
	dispatch: (action: [string, SearchData]) => void;
} 

/*
function _addSwitchTechnologyFilter(monikerFrom, versionFrom, monikerTo, versionTo, when) {

}
*/

// &action:drop;technology:webserver;time:all
/*

{
		type: "action",
		action: "dropped", // dropped
		technology: "Nginx",
	}
*/
function _parseURLFilter(URLFilter: string): CriteriaItem {

	let criteria: CriteriaItem = {type: "include", module: "Custom", child: false, noedit: true};

	let titleAction = ''

	let criteriaValue: wts_ignore_any = {type: "action"};
	const parts = URLFilter.split(';')
	parts.forEach((param: string) => {
		const nameValuePair = param.split(':');
		const name = nameValuePair[0];
		const value = nameValuePair[1];
		if (name == "action") {
			criteriaValue.action = value;

			if (value == "added") {
				titleAction = "Started using";
			}
			else if (value == "dropped") {
				titleAction = "Stopped using";
			}
			else if (value == "versionchanged") {
				titleAction = "Changed version of";
			}
		}
		else if (name == "technology") {
			criteriaValue.technology = value;
		}
	})

	criteria.title = `${titleAction} technology ${criteriaValue.technology}`;
	criteria.value = JSON.stringify(criteriaValue);

	return criteria;
}

const ReportsInitCriteria = (): CriteriaItem[] => {

	// derive search parameters from URL parameters
	let [searchParams, setSearchParams] = useSearchParams();

	console.log(`Search params: ${JSON.stringify(searchParams)}`);

	let criteria: CriteriaItem = {type: "include", module: ""}; // by default we only have inclusions

	const technology = searchParams.get('technology');
	const version = searchParams.get('version');
	const header = searchParams.get('header');
	const category = searchParams.get('category');
	const country = searchParams.get('country');
	const region = searchParams.get('region');
	const language = searchParams.get('language');
	const tld = searchParams.get('tld');

	let arrCriterias: CriteriaItem[] = [];

	if (undefined != technology) {
		criteria.value = technology;
		criteria.version = version; 
		criteria.module ="Technology";
		arrCriterias.push(criteria);
	}
	else if (undefined != header) {
		criteria.value = header;
		criteria.module ="Header";
		arrCriterias.push(criteria);
	} else if (undefined != category) {
		criteria.value = category;
		criteria.module ="Category";
		arrCriterias.push(criteria);	
	}
	else {
		console.log(`[error]: unknown report type`)
	}

	// add general purpose filter (maximum 10 conditions to be safe)
	let filters: string[] = [];
	for (let i = 1; i < 10; ++i) {
		const thisFilter = searchParams.get(`cond${i}`);
		if (undefined == thisFilter){
			break; // last filter
		}
		filters.push(thisFilter);
	}

	filters.forEach((filter: string) => {
		criteria = _parseURLFilter(filter);
		// TODO: add error if there is problem with parsing
		if (undefined != criteria) {
			arrCriterias.push(criteria);
		}
	})
	

	if (undefined != country) {
		criteria = {type: "include", module: "Regions", child: true, value: country};
		arrCriterias.push(criteria);
	}
	if (undefined != region) {
		criteria = {type: "include", module: "Regions", child: false, value: region};
		arrCriterias.push(criteria);
	}
	if (undefined != language) {
		criteria = {type: "include", module: "Languages", child: false, value: language};
		arrCriterias.push(criteria);
	}
	if (undefined != tld) {
		criteria = {type: "include", module: "Top Level Domains (TLD)", child: false, value: tld};
		arrCriterias.push(criteria);
	}
						
	return arrCriterias;
}

export const ReportsRemove = function( state: ReportsBodyLeftState, data: string ): CriteriaItem[] {

	let list = [ ...state.list ];
	let f = list.findIndex(( item ) => item.value === data );

	if( f > -1 )
		list.splice( f, 1 );

	return list;
};
export const ReportsAdd = function( state: ReportsBodyLeftState, data: CriteriaItem | CriteriaItem[] ): CriteriaItem[] {

	let list = [ ...state.list ];
	let items = data;

	if( !Array.isArray( data ) )
		items = [ data ];

	for( let item of items ){

		if( !item.value )
			continue;

		let f = list.find(( f ) => (f.value || "").toLowerCase() === (item.value || "").toLowerCase() );

		if( f ){
			f.type = item.type;
			f.version = item.version;
			f.icon = item.icon;
			f.title = item.title;
			f.module = item.module ? item.module : f.module;
		}else{
			list.push({
				type: item.type,
				value: item.value,
				version: item.version,
				icon: item.icon,
				title: item.title,
				module: item.module
			});
		};

	};

	return list;
};
const ReportsMergeInside = function( list: CriteriaItem[], array: CriteriaItem[], key: string ): void {

	//#removing old data
	for( const index in list ){

		const item = list[ index ];

		if( item.module !== key )
			continue;

		if( array.find(( f ) => (f.value || "").toLowerCase() === (item.value || "").toLowerCase() ) )
			continue;

		list.splice( index, 1 );

	};

	//#adding new data
	for( const item of array ){

		if( list.find(( f ) =>{
				return (
					(f.value || "").toLowerCase() === (item.value || "").toLowerCase()
						&&
					f.module === key
				)
			})
		)
			continue;

		list.push( item );

	};

};
const ReportsMerge = function( state: ReportsBodyLeftState, data: { [key: string]: CriteriaItem[] } ): CriteriaItem[] {

	let list = [ ...state.list ];

	for( const key in data ){
		ReportsMergeInside( list, data[ key ], key );
	};

	return list;
};

const ReportsBodyLeftReducer = function( state: ReportsBodyLeftState, [ type, data ]: [string, wts_ignore_any] ): ReportsBodyLeftState {

	if( type === "toggle" ){
		return {
			...state,
			iteration: state.selected ? state.iteration : (state.iteration + 1),
			focus: "",
			selected: !state.selected
		};
	}else if( type === "open" ){
		return {
			...state,
			iteration: state.iteration + 1,
			focus: "",
			selected: true
		};
	}else if( type === "edit" ){
		return {
			...state,
			iteration: state.iteration + 1,
			focus: data.module,
			selected: true
		};
	}else if( type === "progress" ){
		return {
			...state,
			searchProgress: data.progress,
			searchDiscovered: data.discovered,
			searchMax: data.max,
			searchCompleted: data.completed,
			searchList: [ ...data.domains ]
		};
	}else if( type === "search" ){
		return {
			...state,
			searchToken: data,
			searchProgress: 0,
			searchDiscovered: 0,
			searchCompleted: false,
			searchList: []
		};
	}else if( type === "merge" ){
		return {
			...state,
			list: ReportsMerge( state, data )
		};
	}else if( type === "add" ){
		return {
			...state,
			list: ReportsAdd( state, data )
		};
	}else if( type === "remove" ){
		return {
			...state,
			list: ReportsRemove( state, data )
		};
	}else if( type === "close" ){
		return {
			...state,
			selected: false
		};
	};

	return state;
};

export const ReportsBodyLeft = ( props: ReportsBodyLeftProps ) => {

	const [ state, dispatch ] = useReducer( ReportsBodyLeftReducer, {
		selected: false,
		iteration: 0,
		focus: "",
		searchToken: "",
		searchProgress: 0,
		searchDiscovered: 0,
		searchMax: 5000,
		searchCompleted: false,
		searchList: [],
		list: ReportsInitCriteria()
	});

	useEffect(() => {
		//console.log( state.list );
		//ReportsSearchEncode({ list: state.list });
		ReportsSearch({ list: state.list }, dispatch );
	}, [ state.list ]);

	let queryTimeout = useRef<NodeJS.Timeout | number>( 0 );

	useEffect(() => {

		props.dispatch([ "search", {
			token: state.searchToken,
			progress: state.searchProgress,
			discovered: state.searchDiscovered,
			max: state.searchMax,
			completed: state.searchCompleted,
			list: [ ...state.list ]
		}]);

		if( !state.searchToken || state.searchProgress >= 1.0 )
			return;

		queryTimeout.current = setTimeout(() =>{
			ReportsSearchQuery({ searchToken: state.searchToken }, dispatch );
		}, 1000 );

		return () => {
			clearTimeout( queryTimeout.current );
		};
	}, [ state.searchToken, state.searchProgress ]);

	return(
		<div className={"reports-body-left"}>
			<Heading
				heading={"Create report"}
				//headingDescription={"Add filters to select domains to create a targeted lead list"}
			/>

			<div className={"reports-body-left-wrap"}>

				<Block title={"List of selected options"}>
					<ActionTable list={ state.list } dispatch={ dispatch }/>
				</Block>

				<FiltersSelector
					selected={ state.selected }
					iteration={ state.iteration }
					list={ state.list }
					focus={ state.focus }
					onApply={( table: { [key: string]: CriteriaItem[] } ) => {
						dispatch([ "merge", table ]);
						dispatch([ "close" ]);
					}}
					onCancel={() => {
						dispatch([ "close" ]);
					}}
				/>

				<CallListFilter title={"Add/Edit filters"} onClick={() => {
					dispatch([ "toggle" ]);
				}}/>
				<Block
					title={ "Sample Domains" }
				>
					<PreviewTable progress={ state.searchProgress } list={ state.searchList }/>
				</Block>

			</div>
		</div>
	);
};